import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { rootFetch } from './RootScurityClient';
import '../module_mechanics/Styles/BillingManagement.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUserPlus, 
    faUser, 
    faPhone, 
    faCalendar, 
    faSave, 
    faTimes, 
    faSpinner, 
    faCheckCircle, 
    faExclamationTriangle,
    faStore,
    faExchangeAlt,
    faTag,
    faChevronDown,
    faEnvelope,
    faList,
    faFileAlt,
    faCopy,
    faTrashAlt,
    faArrowLeft,
    faClock,
    faMoneyBill,
    faRefresh,
    faCog,
    faBox,
    faBuilding,
    faUsers,
    faCreditCard,
    faCheck,
    faEye,
    faEyeSlash,
    faHistory,
    faCalendarAlt,
    faRocket,
    faSearch,
    faFilter,
    faSort,
    faSortUp,
    faSortDown,
    faEdit,
    faBan,
    faCheckDouble
} from '@fortawesome/free-solid-svg-icons';
// import "./Styles/Form.css";

// ==============================================
// TRANSLATOR
// ==============================================
const createSubscriptionTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations_subscription');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Subscription Form");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations_subscription', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Add Subscription': 'سبسکرپشن شامل کریں',
                'Edit Subscription': 'سبسکرپشن میں ترمیم کریں',
                'Subscription Details': 'سبسکرپشن کی تفصیلات',
                'Fill in the subscription details below': 'ذیل میں سبسکرپشن کی تفصیلات بھریں',
                'Select User': 'صارف منتخب کریں',
                'Module': 'ماڈیول',
                'Package Type': 'پیکیج کی قسم',
                'Category': 'کیٹیگری',
                'Installation Date': 'تنصیب کی تاریخ',
                'Initial Fee': 'ابتدائی فیس',
                'Yearly Service Fee': 'سالانہ سروس فیس',
                'Renewal Fee': 'تجدید فیس',
                'Status': 'حالت',
                'Payment Status': 'ادائیگی کی حالت',
                'Auto Renew': 'خودکار تجدید',
                'Is Trial': 'ٹرائل ہے',
                'Notes': 'نوٹس',
                'Save Subscription': 'سبسکرپشن محفوظ کریں',
                'Update Subscription': 'سبسکرپشن اپ ڈیٹ کریں',
                'Clear': 'صاف کریں',
                'Saving...': 'محفوظ کر رہے ہیں...',
                'Updating...': 'اپ ڈیٹ کر رہے ہیں...',
                'Subscription saved successfully!': 'سبسکرپشن کامیابی سے محفوظ ہو گئی!',
                'Subscription updated successfully!': 'سبسکرپشن کامیابی سے اپ ڈیٹ ہو گئی!',
                'Subscription renewed successfully!': 'سبسکرپشن کامیابی سے تجدید ہو گئی!',
                'Subscription cancelled successfully!': 'سبسکرپشن کامیابی سے منسوخ ہو گئی!',
                'Failed to save subscription': 'سبسکرپشن محفوظ کرنے میں ناکامی',
                'Failed to update subscription': 'سبسکرپشن اپ ڈیٹ کرنے میں ناکامی',
                'Failed to renew subscription': 'سبسکرپشن تجدید کرنے میں ناکامی',
                'Failed to cancel subscription': 'سبسکرپشن منسوخ کرنے میں ناکامی',
                'Network error occurred': 'نیٹ ورک کی خرابی',
                'User is required': 'صارف کا انتخاب ضروری ہے',
                'Module is required': 'ماڈیول کا انتخاب ضروری ہے',
                'Package type is required': 'پیکیج کی قسم ضروری ہے',
                'Installation date is required': 'تنصیب کی تاریخ ضروری ہے',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Select a user first': 'پہلے ایک صارف منتخب کریں',
                'Loading users...': 'صارفین لوڈ ہو رہے ہیں...',
                'No users available': 'کوئی صارف دستیاب نہیں',
                'Select Module': 'ماڈیول منتخب کریں',
                'Select Package Type': 'پیکیج کی قسم منتخب کریں',
                'Yearly': 'سالانہ',
                '6 Months': '6 ماہ',
                '3 Months': '3 ماہ',
                'Monthly': 'ماہانہ',
                'Production': 'پروڈکشن',
                'Custom': 'کسٹم',
                'Trial': 'ٹرائل',
                'Demo': 'ڈیمو',
                'Active': 'فعال',
                'Inactive': 'غیر فعال',
                'Expired': 'میعاد ختم',
                'Cancelled': 'منسوخ',
                'Pending': 'زیر التواء',
                'Paid': 'ادا شدہ',
                'Unpaid': 'غیر ادا شدہ',
                'Partial': 'جزوی',
                'Overdue': 'تاخیر شدہ',
                'Optional': 'اختیاری',
                'Clear Form': 'فارم صاف کریں',
                'Save Draft': 'ڈرافٹ محفوظ کریں',
                'Drafts': 'ڈرافٹس',
                'Subscriptions': 'سبسکرپشنز',
                'Saved Drafts': 'محفوظ کردہ ڈرافٹس',
                'No drafts saved': 'کوئی ڈرافٹ محفوظ نہیں',
                'Draft loaded': 'ڈرافٹ لوڈ ہو گیا',
                'Draft cleared': 'ڈرافٹ صاف ہو گیا',
                'Total Amount': 'کل رقم',
                'Renewal Date': 'تجدید کی تاریخ',
                'Expiry Date': 'میعاد ختم ہونے کی تاریخ',
                'User Information': 'صارف کی معلومات',
                'Subscription Details': 'سبسکرپشن کی تفصیلات',
                'Pricing': 'قیمت',
                'Advanced Settings': 'اعلیٰ ترتیبات',
                'Calculate automatically': 'خودکار حساب',
                'Expiry Warning': 'انتباہ میعاد ختم',
                'Days Remaining': 'باقی دن',
                'Expired': 'میعاد ختم',
                'Expiring Soon': 'جلد میعاد ختم',
                'Renew': 'تجدید کریں',
                'Cancel': 'منسوخ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'View History': 'تاریخ دیکھیں',
                'Subscription History': 'سبسکرپشن کی تاریخ',
                'No subscriptions found': 'کوئی سبسکرپشن نہیں ملی',
                'Search': 'تلاش کریں',
                'Filter': 'فلٹر کریں',
                'All': 'سب',
                'Active Subscriptions': 'فعال سبسکرپشنز',
                'Expired Subscriptions': 'میعاد ختم سبسکرپشنز',
                'User Status': 'صارف کی حالت',
                'Can Login': 'لاگ ان کر سکتے ہیں',
                'Cannot Login': 'لاگ ان نہیں کر سکتے',
                'Reactivate User': 'صارف کو دوبارہ فعال کریں',
                'User Reactivated': 'صارف دوبارہ فعال ہو گیا'
            },
            'ar': {
                'Add Subscription': 'إضافة اشتراك',
                'Edit Subscription': 'تعديل الاشتراك',
                'Subscription Details': 'تفاصيل الاشتراك',
                'Fill in the subscription details below': 'املأ تفاصيل الاشتراك أدناه',
                'Select User': 'اختر المستخدم',
                'Module': 'الوحدة',
                'Package Type': 'نوع الباقة',
                'Category': 'الفئة',
                'Installation Date': 'تاريخ التثبيت',
                'Initial Fee': 'الرسوم الأولية',
                'Yearly Service Fee': 'رسوم الخدمة السنوية',
                'Renewal Fee': 'رسوم التجديد',
                'Status': 'الحالة',
                'Payment Status': 'حالة الدفع',
                'Auto Renew': 'تجديد تلقائي',
                'Is Trial': 'نسخة تجريبية',
                'Notes': 'ملاحظات',
                'Save Subscription': 'حفظ الاشتراك',
                'Update Subscription': 'تحديث الاشتراك',
                'Clear': 'مسح',
                'Saving...': 'جاري الحفظ...',
                'Updating...': 'جاري التحديث...',
                'Subscription saved successfully!': 'تم حفظ الاشتراك بنجاح!',
                'Subscription updated successfully!': 'تم تحديث الاشتراك بنجاح!',
                'Subscription renewed successfully!': 'تم تجديد الاشتراك بنجاح!',
                'Subscription cancelled successfully!': 'تم إلغاء الاشتراك بنجاح!',
                'Failed to save subscription': 'فشل في حفظ الاشتراك',
                'Failed to update subscription': 'فشل في تحديث الاشتراك',
                'Failed to renew subscription': 'فشل في تجديد الاشتراك',
                'Failed to cancel subscription': 'فشل في إلغاء الاشتراك',
                'Network error occurred': 'حدث خطأ في الشبكة',
                'User is required': 'المستخدم مطلوب',
                'Module is required': 'الوحدة مطلوبة',
                'Package type is required': 'نوع الباقة مطلوب',
                'Installation date is required': 'تاريخ التثبيت مطلوب',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Select a user first': 'اختر مستخدمًا أولاً',
                'Loading users...': 'جاري تحميل المستخدمين...',
                'No users available': 'لا يوجد مستخدمين متاحين',
                'Select Module': 'اختر الوحدة',
                'Select Package Type': 'اختر نوع الباقة',
                'Yearly': 'سنوي',
                '6 Months': '6 أشهر',
                '3 Months': '3 أشهر',
                'Monthly': 'شهري',
                'Production': 'إنتاج',
                'Custom': 'مخصص',
                'Trial': 'نسخة تجريبية',
                'Demo': 'عرض توضيحي',
                'Active': 'نشط',
                'Inactive': 'غير نشط',
                'Expired': 'منتهي الصلاحية',
                'Cancelled': 'ملغى',
                'Pending': 'معلق',
                'Paid': 'مدفوع',
                'Unpaid': 'غير مدفوع',
                'Partial': 'جزئي',
                'Overdue': 'متأخر',
                'Optional': 'اختياري',
                'Clear Form': 'مسح النموذج',
                'Save Draft': 'حفظ المسودة',
                'Drafts': 'المسودات',
                'Subscriptions': 'الاشتراكات',
                'Saved Drafts': 'المسودات المحفوظة',
                'No drafts saved': 'لا توجد مسودات محفوظة',
                'Draft loaded': 'تم تحميل المسودة',
                'Draft cleared': 'تم مسح المسودة',
                'Total Amount': 'المبلغ الإجمالي',
                'Renewal Date': 'تاريخ التجديد',
                'Expiry Date': 'تاريخ الانتهاء',
                'User Information': 'معلومات المستخدم',
                'Subscription Details': 'تفاصيل الاشتراك',
                'Pricing': 'التسعير',
                'Advanced Settings': 'إعدادات متقدمة',
                'Calculate automatically': 'حساب تلقائي',
                'Expiry Warning': 'تحذير انتهاء الصلاحية',
                'Days Remaining': 'الأيام المتبقية',
                'Expired': 'منتهي الصلاحية',
                'Expiring Soon': 'ينتهي قريباً',
                'Renew': 'تجديد',
                'Cancel': 'إلغاء',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'View History': 'عرض التاريخ',
                'Subscription History': 'تاريخ الاشتراك',
                'No subscriptions found': 'لا توجد اشتراكات',
                'Search': 'بحث',
                'Filter': 'فلتر',
                'All': 'الكل',
                'Active Subscriptions': 'الاشتراكات النشطة',
                'Expired Subscriptions': 'الاشتراكات المنتهية',
                'User Status': 'حالة المستخدم',
                'Can Login': 'يمكن تسجيل الدخول',
                'Cannot Login': 'لا يمكن تسجيل الدخول',
                'Reactivate User': 'إعادة تنشيط المستخدم',
                'User Reactivated': 'تم إعادة تنشيط المستخدم'
            },
            'es': {
                'Add Subscription': 'Agregar Suscripción',
                'Edit Subscription': 'Editar Suscripción',
                'Subscription Details': 'Detalles de la Suscripción',
                'Fill in the subscription details below': 'Complete los detalles de la suscripción a continuación',
                'Select User': 'Seleccionar Usuario',
                'Module': 'Módulo',
                'Package Type': 'Tipo de Paquete',
                'Category': 'Categoría',
                'Installation Date': 'Fecha de Instalación',
                'Initial Fee': 'Cuota Inicial',
                'Yearly Service Fee': 'Cuota de Servicio Anual',
                'Renewal Fee': 'Cuota de Renovación',
                'Status': 'Estado',
                'Payment Status': 'Estado de Pago',
                'Auto Renew': 'Renovación Automática',
                'Is Trial': 'Es Prueba',
                'Notes': 'Notas',
                'Save Subscription': 'Guardar Suscripción',
                'Update Subscription': 'Actualizar Suscripción',
                'Clear': 'Limpiar',
                'Saving...': 'Guardando...',
                'Updating...': 'Actualizando...',
                'Subscription saved successfully!': '¡Suscripción guardada exitosamente!',
                'Subscription updated successfully!': '¡Suscripción actualizada exitosamente!',
                'Subscription renewed successfully!': '¡Suscripción renovada exitosamente!',
                'Subscription cancelled successfully!': '¡Suscripción cancelada exitosamente!',
                'Failed to save subscription': 'Error al guardar la suscripción',
                'Failed to update subscription': 'Error al actualizar la suscripción',
                'Failed to renew subscription': 'Error al renovar la suscripción',
                'Failed to cancel subscription': 'Error al cancelar la suscripción',
                'Network error occurred': 'Ocurrió un error de red',
                'User is required': 'El usuario es requerido',
                'Module is required': 'El módulo es requerido',
                'Package type is required': 'El tipo de paquete es requerido',
                'Installation date is required': 'La fecha de instalación es requerida',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Select a user first': 'Seleccione un usuario primero',
                'Loading users...': 'Cargando usuarios...',
                'No users available': 'No hay usuarios disponibles',
                'Select Module': 'Seleccionar Módulo',
                'Select Package Type': 'Seleccionar Tipo de Paquete',
                'Yearly': 'Anual',
                '6 Months': '6 Meses',
                '3 Months': '3 Meses',
                'Monthly': 'Mensual',
                'Production': 'Producción',
                'Custom': 'Personalizado',
                'Trial': 'Prueba',
                'Demo': 'Demostración',
                'Active': 'Activo',
                'Inactive': 'Inactivo',
                'Expired': 'Expirado',
                'Cancelled': 'Cancelado',
                'Pending': 'Pendiente',
                'Paid': 'Pagado',
                'Unpaid': 'No Pagado',
                'Partial': 'Parcial',
                'Overdue': 'Vencido',
                'Optional': 'Opcional',
                'Clear Form': 'Limpiar Formulario',
                'Save Draft': 'Guardar Borrador',
                'Drafts': 'Borradores',
                'Subscriptions': 'Suscripciones',
                'Saved Drafts': 'Borradores Guardados',
                'No drafts saved': 'No hay borradores guardados',
                'Draft loaded': 'Borrador cargado',
                'Draft cleared': 'Borrador limpiado',
                'Total Amount': 'Monto Total',
                'Renewal Date': 'Fecha de Renovación',
                'Expiry Date': 'Fecha de Vencimiento',
                'User Information': 'Información del Usuario',
                'Subscription Details': 'Detalles de la Suscripción',
                'Pricing': 'Precios',
                'Advanced Settings': 'Configuración Avanzada',
                'Calculate automatically': 'Calcular automáticamente',
                'Expiry Warning': 'Advertencia de Vencimiento',
                'Days Remaining': 'Días Restantes',
                'Expired': 'Expirado',
                'Expiring Soon': 'Próximo a Vencer',
                'Renew': 'Renovar',
                'Cancel': 'Cancelar',
                'Edit': 'Editar',
                'Delete': 'Eliminar',
                'View History': 'Ver Historial',
                'Subscription History': 'Historial de Suscripción',
                'No subscriptions found': 'No se encontraron suscripciones',
                'Search': 'Buscar',
                'Filter': 'Filtrar',
                'All': 'Todos',
                'Active Subscriptions': 'Suscripciones Activas',
                'Expired Subscriptions': 'Suscripciones Expiradas',
                'User Status': 'Estado del Usuario',
                'Can Login': 'Puede Iniciar Sesión',
                'Cannot Login': 'No Puede Iniciar Sesión',
                'Reactivate User': 'Reactivar Usuario',
                'User Reactivated': 'Usuario Reactivado'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed, trying MyMemory");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory translation failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        addSubscription: 'Add Subscription',
        editSubscription: 'Edit Subscription',
        subscriptionDetails: 'Subscription Details',
        fillDetails: 'Fill in the subscription details below',
        selectUser: 'Select User',
        module: 'Module',
        packageType: 'Package Type',
        category: 'Category',
        installationDate: 'Installation Date',
        initialFee: 'Initial Fee',
        yearlyServiceFee: 'Yearly Service Fee',
        renewalFee: 'Renewal Fee',
        status: 'Status',
        paymentStatus: 'Payment Status',
        autoRenew: 'Auto Renew',
        isTrial: 'Is Trial',
        notes: 'Notes',
        saveSubscription: 'Save Subscription',
        updateSubscription: 'Update Subscription',
        clear: 'Clear',
        saving: 'Saving...',
        updating: 'Updating...',
        subscriptionSaved: 'Subscription saved successfully!',
        subscriptionUpdated: 'Subscription updated successfully!',
        subscriptionRenewed: 'Subscription renewed successfully!',
        subscriptionCancelled: 'Subscription cancelled successfully!',
        failedSave: 'Failed to save subscription',
        failedUpdate: 'Failed to update subscription',
        failedRenew: 'Failed to renew subscription',
        failedCancel: 'Failed to cancel subscription',
        networkError: 'Network error occurred',
        userRequired: 'User is required',
        moduleRequired: 'Module is required',
        packageTypeRequired: 'Package type is required',
        installationDateRequired: 'Installation date is required',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectUserFirst: 'Select a user first',
        loadingUsers: 'Loading users...',
        noUsers: 'No users available',
        selectModule: 'Select Module',
        selectPackageType: 'Select Package Type',
        yearly: 'Yearly',
        sixMonths: '6 Months',
        threeMonths: '3 Months',
        monthly: 'Monthly',
        production: 'Production',
        custom: 'Custom',
        trial: 'Trial',
        demo: 'Demo',
        active: 'Active',
        inactive: 'Inactive',
        expired: 'Expired',
        cancelled: 'Cancelled',
        pending: 'Pending',
        paid: 'Paid',
        unpaid: 'Unpaid',
        partial: 'Partial',
        overdue: 'Overdue',
        optional: 'Optional',
        clearForm: 'Clear Form',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        subscriptions: 'Subscriptions',
        savedDrafts: 'Saved Drafts',
        noDraftsSaved: 'No drafts saved',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        totalAmount: 'Total Amount',
        renewalDate: 'Renewal Date',
        expiryDate: 'Expiry Date',
        userInformation: 'User Information',
        subscriptionDetails: 'Subscription Details',
        pricing: 'Pricing',
        advancedSettings: 'Advanced Settings',
        calculateAuto: 'Calculate automatically',
        expiryWarning: 'Expiry Warning',
        daysRemaining: 'Days Remaining',
        expired: 'Expired',
        expiringSoon: 'Expiring Soon',
        renew: 'Renew',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        viewHistory: 'View History',
        subscriptionHistory: 'Subscription History',
        noSubscriptions: 'No subscriptions found',
        search: 'Search',
        filter: 'Filter',
        all: 'All',
        activeSubscriptions: 'Active Subscriptions',
        expiredSubscriptions: 'Expired Subscriptions',
        userStatus: 'User Status',
        canLogin: 'Can Login',
        cannotLogin: 'Cannot Login',
        reactivateUser: 'Reactivate User',
        userReactivated: 'User Reactivated'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const subscriptionTranslator = createSubscriptionTranslator();

// ==============================================
// TOAST NOTIFICATION
// ==============================================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ==============================================
// SUBSCRIPTION CARD COMPONENT
// ==============================================
const SubscriptionCard = ({ subscription, onRenew, onCancel, onEdit, onDelete, onViewHistory, translations, isRTL }) => {
    const isExpired = subscription.is_expired || subscription.status === 'expired';
    const isExpiringSoon = !isExpired && subscription.days_remaining <= 7;
    const statusColors = {
        active: '#10b981',
        inactive: '#6b7280',
        expired: '#ef4444',
        cancelled: '#f59e0b',
        pending: '#f59e0b'
    };

    const getStatusColor = (status) => {
        return statusColors[status] || '#6b7280';
    };

    return (
        <div className={`ozui-subscription-card ${isExpired ? 'ozui-expired-card' : ''} ${isExpiringSoon ? 'ozui-expiring-card' : ''}`}>
            <div className="ozui-card-header">
                <div className="ozui-card-module">
                    <h3>{subscription.module_name || subscription.module}</h3>
                    <span className="ozui-module-code">{subscription.module}</span>
                </div>
                <div className="ozui-card-status">
                    <span 
                        className="ozui-status-badge" 
                        style={{ backgroundColor: getStatusColor(subscription.status) }}
                    >
                        {subscription.status_label || subscription.status}
                    </span>
                    {subscription.payment_status && (
                        <span className={`ozui-payment-badge ozui-payment-${subscription.payment_status}`}>
                            {subscription.payment_status}
                        </span>
                    )}
                </div>
            </div>

            <div className="ozui-card-body">
                <div className="ozui-card-user">
                    <FontAwesomeIcon icon={faUser} />
                    <span>{subscription.user_fullname || subscription.user_username || 'User'}</span>
                </div>
                
                <div className="ozui-card-dates">
                    <div className="ozui-date-item">
                        <span className="ozui-date-label">
                            <FontAwesomeIcon icon={faCalendar} /> {translations.installationDate || 'Installation'}
                        </span>
                        <span className="ozui-date-value">{subscription.installation_date}</span>
                    </div>
                    <div className="ozui-date-item">
                        <span className="ozui-date-label">
                            <FontAwesomeIcon icon={faClock} /> {translations.renewalDate || 'Renewal'}
                        </span>
                        <span className="ozui-date-value">{subscription.renewal_date}</span>
                    </div>
                    <div className="ozui-date-item">
                        <span className="ozui-date-label">
                            <FontAwesomeIcon icon={faExclamationTriangle} /> {translations.expiryDate || 'Expiry'}
                        </span>
                        <span className={`ozui-date-value ${isExpired ? 'ozui-expired-date' : ''} ${isExpiringSoon ? 'ozui-expiring-date' : ''}`}>
                            {subscription.expiry_date}
                        </span>
                    </div>
                </div>

                <div className="ozui-card-pricing">
                    <div className="ozui-price-item">
                        <span className="ozui-price-label">{translations.totalAmount || 'Total'}</span>
                      <span className="ozui-price-value">PKR {subscription.total_amount}</span>
                    </div>
                    <div className="ozui-price-item">
                        <span className="ozui-price-label">{translations.daysRemaining || 'Days Left'}</span>
                        <span className={`ozui-days-value ${isExpired ? 'ozui-expired' : ''} ${isExpiringSoon ? 'ozui-expiring' : ''}`}>
                            {isExpired ? '0' : subscription.days_remaining}
                        </span>
                    </div>
                </div>
            </div>

            <div className="ozui-card-actions">
                {!isExpired && subscription.status === 'active' && (
                    <button 
                        className="ozui-action-btn ozui-renew-btn"
                        onClick={() => onRenew(subscription.id)}
                    >
                        <FontAwesomeIcon icon={faRefresh} />
                        {translations.renew || 'Renew'}
                    </button>
                )}
                
                {subscription.status !== 'cancelled' && subscription.status !== 'expired' && (
                    <button 
                        className="ozui-action-btn ozui-cancel-btn"
                        onClick={() => onCancel(subscription.id)}
                    >
                        <FontAwesomeIcon icon={faBan} />
                        {translations.cancel || 'Cancel'}
                    </button>
                )}
                
                <button 
                    className="ozui-action-btn ozui-edit-btn"
                    onClick={() => onEdit(subscription)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                    {translations.edit || 'Edit'}
                </button>
                
                <button 
                    className="ozui-action-btn ozui-history-btn"
                    onClick={() => onViewHistory(subscription.id)}
                >
                    <FontAwesomeIcon icon={faHistory} />
                    {translations.viewHistory || 'History'}
                </button>
            </div>
        </div>
    );
};

// ==============================================
// SUBSCRIPTION HISTORY MODAL
// ==============================================
const HistoryModal = ({ isOpen, onClose, history, loading, translations, isRTL }) => {
    if (!isOpen) return null;

    return (
        <div className="ozui-modal-overlay" onClick={onClose}>
            <div className="ozui-modal ozui-history-modal" onClick={e => e.stopPropagation()}>
                <div className="ozui-modal-header">
                    <h3>
                        <FontAwesomeIcon icon={faHistory} />
                        {translations.subscriptionHistory || 'Subscription History'}
                    </h3>
                    <button className="ozui-modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui-modal-body">
                    {loading ? (
                        <div className="ozui-loading-state">
                            <FontAwesomeIcon icon={faSpinner} spin />
                            <span>Loading history...</span>
                        </div>
                    ) : history.length === 0 ? (
                        <div className="ozui-empty-state">No history available</div>
                    ) : (
                        <div className="ozui-history-list">
                            {history.map((item, index) => (
                                <div key={index} className="ozui-history-item">
                                    <div className="ozui-history-action">
                                        <span className="ozui-action-badge">{item.action}</span>
                                        <span className="ozui-history-date">
                                            {new Date(item.created_at).toLocaleString()}
                                        </span>
                                    </div>
                                    <div className="ozui-history-details">
                                        {item.old_status && item.new_status && (
                                            <span>
                                                Status: {item.old_status} → {item.new_status}
                                            </span>
                                        )}
                                     {item.amount && (
    <span>Amount: PKR {item.amount}</span>
)}
                                        {item.notes && (
                                            <span className="ozui-history-notes">{item.notes}</span>
                                        )}
                                        {item.performed_by_username && (
                                            <span className="ozui-history-performed">
                                                By: {item.performed_by_fullname || item.performed_by_username}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ==============================================
// MAIN COMPONENT
// ==============================================
const AddSubscription = ({ onSubscriptionAdded, onNavigate, editData }) => {
    const { user, currentShop } = useAuth();
    
    const userInputRef = useRef(null);
    
    const initialFormData = {
        id: null,
        user_id: '',
        module: '',
        package_type: '',
        category: 'production',
        installation_date: new Date().toISOString().split('T')[0],
        initial_fee: 0,
        yearly_service_fee: 0,
        renewal_fee: 0,
        status: 'active',
        payment_status: 'unpaid',
        auto_renew: 1,
        is_trial: 0,
        notes: '',
        features: {},
        subscription_metadata: {}
    };
    
    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [translations, setTranslations] = useState({});
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [availableUsers, setAvailableUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [modules, setModules] = useState([]);
    const [loadingModules, setLoadingModules] = useState(false);
    const [showModuleDropdown, setShowModuleDropdown] = useState(false);
    const [moduleSearchTerm, setModuleSearchTerm] = useState('');
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    const [autoCalcTotal, setAutoCalcTotal] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(false);
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
    const [filterStatus, setFilterStatus] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    
    const isSubmittingRef = useRef(false);
    const toastTimerRef = useRef(null);
    const formRef = useRef(null);
    const userDropdownRef = useRef(null);
    const moduleDropdownRef = useRef(null);
    const draftsDropdownRef = useRef(null);
    const submitButtonRef = useRef(null);

    // ============================================
    // FETCH USERS AND MODULES
    // ============================================
    const fetchUsers = async () => {
        setLoadingUsers(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/root_users.php?action=list&limit=100`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (!response.ok) throw new Error('Failed to fetch users');
            const data = await response.json();
            
            if (data.success) {
                setAvailableUsers(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchModules = async () => {
        setLoadingModules(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php?action=get_modules`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (!response.ok) throw new Error('Failed to fetch modules');
            const data = await response.json();
            
            if (data.success) {
                setModules(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching modules:', error);
        } finally {
            setLoadingModules(false);
        }
    };

    const fetchUserSubscriptions = async (userId) => {
        if (!userId) return;
        setLoadingSubscriptions(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php?action=get_user_subscriptions&user_id=${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (!response.ok) throw new Error('Failed to fetch subscriptions');
            const data = await response.json();
            
            if (data.success) {
                setSubscriptions(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
        } finally {
            setLoadingSubscriptions(false);
        }
    };

    const fetchSubscriptionHistory = async (subscriptionId) => {
        setLoadingHistory(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php?action=get_subscription_history&subscription_id=${subscriptionId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (!response.ok) throw new Error('Failed to fetch history');
            const data = await response.json();
            
            if (data.success) {
                setHistoryData(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching history:', error);
        } finally {
            setLoadingHistory(false);
        }
    };

    useEffect(() => {
        fetchUsers();
        fetchModules();
    }, []);

    // Load subscriptions when user is selected
    useEffect(() => {
        if (formData.user_id) {
            fetchUserSubscriptions(formData.user_id);
        } else {
            setSubscriptions([]);
        }
    }, [formData.user_id]);

    // Load edit data if provided
    useEffect(() => {
        if (editData) {
            setFormData({
                id: editData.id,
                user_id: editData.user_id,
                module: editData.module,
                package_type: editData.package_type,
                category: editData.category || 'production',
                installation_date: editData.installation_date,
                initial_fee: editData.initial_fee || 0,
                yearly_service_fee: editData.yearly_service_fee || 0,
                renewal_fee: editData.renewal_fee || 0,
                status: editData.status || 'active',
                payment_status: editData.payment_status || 'unpaid',
                auto_renew: editData.auto_renew || 1,
                is_trial: editData.is_trial || 0,
                notes: editData.notes || '',
                features: editData.features || {},
                subscription_metadata: editData.subscription_metadata || {}
            });
            
            // Set search terms
            if (editData.user_id) {
                const user = availableUsers.find(u => u.id === editData.user_id);
                setUserSearchTerm(user ? user.fullname || user.username : '');
            }
            if (editData.module) {
                const module = modules.find(m => m.module_code === editData.module);
                setModuleSearchTerm(module ? module.module_name : '');
            }
        }
    }, [editData, availableUsers, modules]);

    // ============================================
    // DRAFT MANAGEMENT
    // ============================================
    const saveDraft = () => {
        if (!formData.user_id && !formData.module) {
            showToast('warning', 'Cannot save empty draft');
            return;
        }
        
        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };
        
        const existingDrafts = JSON.parse(localStorage.getItem('subscription_drafts') || '[]');
        existingDrafts.unshift(draft);
        const limitedDrafts = existingDrafts.slice(0, 20);
        localStorage.setItem('subscription_drafts', JSON.stringify(limitedDrafts));
        
        showToast('success', translations.draftLoaded || 'Draft saved successfully!');
        loadDrafts();
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('subscription_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
    };

    const loadDraft = (draft) => {
        setFormData({
            id: draft.id || null,
            user_id: draft.user_id || '',
            module: draft.module || '',
            package_type: draft.package_type || '',
            category: draft.category || 'production',
            installation_date: draft.installation_date || new Date().toISOString().split('T')[0],
            initial_fee: draft.initial_fee || 0,
            yearly_service_fee: draft.yearly_service_fee || 0,
            renewal_fee: draft.renewal_fee || 0,
            status: draft.status || 'active',
            payment_status: draft.payment_status || 'unpaid',
            auto_renew: draft.auto_renew || 1,
            is_trial: draft.is_trial || 0,
            notes: draft.notes || '',
            features: draft.features || {},
            subscription_metadata: draft.subscription_metadata || {}
        });
        
        if (draft.user_id) {
            const user = availableUsers.find(u => u.id === draft.user_id);
            setUserSearchTerm(user ? user.fullname || user.username : '');
        }
        if (draft.module) {
            const module = modules.find(m => m.module_code === draft.module);
            setModuleSearchTerm(module ? module.module_name : '');
        }
        
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('subscription_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('subscription_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    // ============================================
    // THEME, DARK MODE, LANGUAGE SYNC
    // ============================================
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        document.documentElement.style.setProperty('--ozui-primary', color);
        document.documentElement.style.setProperty('--ozui-primary-dark', color);
        document.documentElement.style.setProperty('--ozui-primary-light', color);
        
        const updateOrbColors = () => {
            let r, g, b;
            if (color.startsWith('#')) {
                r = parseInt(color.slice(1, 3), 16);
                g = parseInt(color.slice(3, 5), 16);
                b = parseInt(color.slice(5, 7), 16);
            } else {
                r = 99; g = 102; b = 241;
            }
            
            let style = document.getElementById('dynamic-orb-styles');
            if (!style) {
                style = document.createElement('style');
                style.id = 'dynamic-orb-styles';
                document.head.appendChild(style);
            }
            
            style.textContent = `
                .ozui-header-bg-animation .gradient-orb.orb-1 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-2 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-3 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-4 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-5 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
                }
            `;
        };
        
        updateOrbColors();
        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };
        
        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
        };
    }, [applyTheme]);

    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);
            
            const container = document.querySelector('.ozui-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('ozui-dark');
                } else {
                    container.classList.remove('ozui-dark');
                }
            }
            
            if (isDarkMode) {
                document.body.classList.add('ozui-dark');
                document.documentElement.classList.add('ozui-dark');
            } else {
                document.body.classList.remove('ozui-dark');
                document.documentElement.classList.remove('ozui-dark');
            }
        };
        
        syncDarkMode();
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };
        
        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozui-dark');
                    } else {
                        container.classList.remove('ozui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozui-dark');
                    document.documentElement.classList.add('ozui-dark');
                } else {
                    document.body.classList.remove('ozui-dark');
                    document.documentElement.classList.remove('ozui-dark');
                }
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await subscriptionTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        
        loadTranslations(currentLanguage);
        
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
        };
    }, [currentLanguage]);

    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozui-container');
        
        if (container) {
            if (isRTL) {
                container.classList.add('ozui-rtl');
                container.classList.remove('ozui-ltr');
            } else {
                container.classList.add('ozui-ltr');
                container.classList.remove('ozui-rtl');
            }
        }
        
        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // ============================================
    // TOAST AND UTILITY FUNCTIONS
    // ============================================
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    }, []);

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
            isSubmittingRef.current = false;
        };
    }, []);

    // ============================================
    // FORM HANDLERS
    // ============================================
    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.user_id) {
            newErrors.user_id = translations.userRequired || 'User is required';
        }
        
        if (!formData.module) {
            newErrors.module = translations.moduleRequired || 'Module is required';
        }
        
        if (!formData.package_type) {
            newErrors.package_type = translations.packageTypeRequired || 'Package type is required';
        }
        
        if (!formData.installation_date) {
            newErrors.installation_date = translations.installationDateRequired || 'Installation date is required';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? (checked ? 1 : 0) : value;
        
        setFormData(prev => ({ ...prev, [name]: val }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const selectUser = (user) => {
        setFormData(prev => ({ ...prev, user_id: user.id }));
        setUserSearchTerm(user.fullname || user.username);
        setShowUserDropdown(false);
        if (errors.user_id) setErrors(prev => ({ ...prev, user_id: '' }));
    };

    const selectModule = (module) => {
        setFormData(prev => ({ 
            ...prev, 
            module: module.module_code,
            initial_fee: module.default_price || 0,
            yearly_service_fee: module.yearly_service_fee || 0,
            renewal_fee: module.renewal_fee || 0
        }));
        setModuleSearchTerm(module.module_name);
        setShowModuleDropdown(false);
        if (errors.module) setErrors(prev => ({ ...prev, module: '' }));
    };

    const handleClear = () => {
        setFormData(initialFormData);
        setUserSearchTerm('');
        setModuleSearchTerm('');
        setErrors({});
        setSubscriptions([]);
        showToast('success', translations.draftCleared || 'Form cleared');
    };

    // ============================================
    // SUBSCRIPTION ACTIONS
    // ============================================
    const handleRenew = async (subscriptionId) => {
        if (!window.confirm('Are you sure you want to renew this subscription?')) return;
        
        setLoading(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'renew_subscription',
                    subscription_id: subscriptionId,
                    performed_by: user?.id || 1
                })
            });
            
            const data = await response.json();
            
            if (data.success) {
                showToast('success', translations.subscriptionRenewed || 'Subscription renewed successfully!');
                // Refresh subscriptions
                if (formData.user_id) {
                    fetchUserSubscriptions(formData.user_id);
                }
            } else {
                showToast('error', data.error || translations.failedRenew || 'Failed to renew subscription');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async (subscriptionId) => {
        if (!window.confirm('Are you sure you want to cancel this subscription?')) return;
        
        setLoading(true);
        try {
            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'cancel_subscription',
                    subscription_id: subscriptionId,
                    performed_by: user?.id || 1,
                    reason: 'Cancelled by user'
                })
            });
            
            const data = await response.json();
            
            if (data.success) {
                showToast('success', translations.subscriptionCancelled || 'Subscription cancelled successfully!');
                if (formData.user_id) {
                    fetchUserSubscriptions(formData.user_id);
                }
            } else {
                showToast('error', data.error || translations.failedCancel || 'Failed to cancel subscription');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            setLoading(false);
        }
    };

    const handleViewHistory = async (subscriptionId) => {
        setSelectedSubscriptionId(subscriptionId);
        setShowHistoryModal(true);
        await fetchSubscriptionHistory(subscriptionId);
    };

    const handleEdit = (subscription) => {
        // Pass subscription data to parent for editing
        if (onNavigate) {
            onNavigate('edit', subscription);
        }
    };

    // ============================================
    // SUBMIT HANDLER
    // ============================================
    const submitSubscription = async (submitData) => {
        if (isSubmittingRef.current) return false;
        isSubmittingRef.current = true;
        setLoading(true);

        try {
            const totalAmount = (
                parseFloat(submitData.initial_fee || 0) + 
                parseFloat(submitData.yearly_service_fee || 0) + 
                parseFloat(submitData.renewal_fee || 0)
            );

            // Determine if creating or updating
            const isEdit = !!submitData.id;
            const action = isEdit ? 'update_subscription' : 'create_subscription';
            
            const payload = {
                action: action,
                user_id: submitData.user_id,
                module: submitData.module,
                package_type: submitData.package_type,
                category: submitData.category || 'production',
                installation_date: submitData.installation_date,
                initial_fee: parseFloat(submitData.initial_fee || 0),
                yearly_service_fee: parseFloat(submitData.yearly_service_fee || 0),
                renewal_fee: parseFloat(submitData.renewal_fee || 0),
                status: submitData.status || 'active',
                payment_status: submitData.payment_status || 'unpaid',
                auto_renew: submitData.auto_renew || 1,
                is_trial: submitData.is_trial || 0,
                notes: submitData.notes || '',
                created_by: user?.id || 1
            };

            if (isEdit) {
                payload.subscription_id = submitData.id;
                payload.performed_by = user?.id || 1;
            }

            const response = await rootFetch(`https://ourzestapp.online/oz_backend/subscription.php`, {
                method: isEdit ? 'PUT' : 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                const message = isEdit ? 
                    translations.subscriptionUpdated || 'Subscription updated successfully!' : 
                    translations.subscriptionSaved || 'Subscription saved successfully!';
                showToast('success', message);
                setFormData(initialFormData);
                setUserSearchTerm('');
                setModuleSearchTerm('');
                setErrors({});
                
                if (onSubscriptionAdded) {
                    onSubscriptionAdded(data.data);
                }
                return true;
            } else {
                showToast('error', data.error || (isEdit ? translations.failedUpdate : translations.failedSave));
                return false;
            }
        } catch (error) {
            console.error('Error submitting subscription:', error);
            showToast('error', translations.networkError || 'Network error occurred');
            return false;
        } finally {
            setLoading(false);
            setTimeout(() => {
                isSubmittingRef.current = false;
            }, 1000);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmittingRef.current) return;
        if (!validateForm()) return;
        
        await submitSubscription(formData);
    };

    // ============================================
    // FILTER FUNCTIONS
    // ============================================
    const filteredUsers = userSearchTerm.trim() === '' 
        ? availableUsers 
        : availableUsers.filter(u => 
            (u.fullname && u.fullname.toLowerCase().includes(userSearchTerm.toLowerCase())) ||
            (u.username && u.username.toLowerCase().includes(userSearchTerm.toLowerCase())) ||
            (u.email && u.email.toLowerCase().includes(userSearchTerm.toLowerCase()))
        );

    const filteredModules = moduleSearchTerm.trim() === '' 
        ? modules 
        : modules.filter(m => 
            m.module_name.toLowerCase().includes(moduleSearchTerm.toLowerCase()) ||
            m.module_code.toLowerCase().includes(moduleSearchTerm.toLowerCase())
        );

    const filteredSubscriptions = subscriptions.filter(sub => {
        if (filterStatus === 'all') return true;
        if (filterStatus === 'active') return sub.status === 'active' && !sub.is_expired;
        if (filterStatus === 'expired') return sub.is_expired || sub.status === 'expired';
        if (filterStatus === 'expiring') return !sub.is_expired && sub.status === 'active' && sub.days_remaining <= 7;
        return true;
    }).filter(sub => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        return (sub.module_name || '').toLowerCase().includes(term) ||
               (sub.module || '').toLowerCase().includes(term) ||
               (sub.user_fullname || '').toLowerCase().includes(term) ||
               (sub.user_username || '').toLowerCase().includes(term);
    });

    // ============================================
    // CLICK OUTSIDE HANDLERS
    // ============================================
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
                setShowUserDropdown(false);
            }
            if (moduleDropdownRef.current && !moduleDropdownRef.current.contains(event.target)) {
                setShowModuleDropdown(false);
            }
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // ============================================
    // RENDER
    // ============================================
    return (
        <div className={`ozui-container ${isRTL ? 'ozui-rtl' : 'ozui-ltr'} ${darkMode ? 'ozui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <HistoryModal 
                isOpen={showHistoryModal}
                onClose={() => {
                    setShowHistoryModal(false);
                    setHistoryData([]);
                }}
                history={historyData}
                loading={loadingHistory}
                translations={translations}
                isRTL={isRTL}
            />

            {/* Header */}
            <div className="ozui-sticky-header">
                <div className="ozui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozui-header-content">
                    <div className="ozui-header-left">
                        <div className="ozui-header-title">
                            <h1>
                                <FontAwesomeIcon icon={faRocket} style={{ marginRight: '12px' }} />
                                {formData.id ? translations.editSubscription || 'Edit Subscription' : translations.addSubscription || 'Add Subscription'}
                            </h1>
                            <p>{translations.fillDetails || 'Fill in the subscription details below'}</p>
                        </div>
                    </div>
                    
                    <div className="ozui-header-right">
                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearForm || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>{translations.clear || 'Clear'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={saveDraft}
                                disabled={loading}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>
                            
                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>
                                
                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => {
                                                    const user = availableUsers.find(u => u.id === draft.user_id);
                                                    const module = modules.find(m => m.module_code === draft.module);
                                                    return (
                                                        <div key={draft.id} className="draft-item">
                                                            <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                                <div className="draft-name">
                                                                    {user ? user.fullname || user.username : 'Unknown User'}
                                                                    {module && ` - ${module.module_name}`}
                                                                </div>
                                                                <div className="draft-details">
                                                                    {draft.package_type && <span>{draft.package_type}</span>}
                                                                    {draft.installation_date && <span>{draft.installation_date}</span>}
                                                                </div>
                                                                <div className="draft-date">
                                                                    {new Date(draft.savedAt).toLocaleDateString()}
                                                                </div>
                                                            </div>
                                                            <button 
                                                                className="delete-draft-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    deleteDraft(draft.id);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </button>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form */}
            <form ref={formRef} onSubmit={handleSubmit} className="ozui-form">
                <div className="ozui-form-row">
                    {/* User Selection */}
                    <div className={`ozui-field ${errors.user_id ? 'ozui-error' : ''}`} ref={userDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                ref={userInputRef}
                                type="text"
                                id="user_id"
                                value={userSearchTerm}
                                onChange={(e) => {
                                    setUserSearchTerm(e.target.value);
                                    setShowUserDropdown(true);
                                    if (formData.user_id) {
                                        setFormData(prev => ({ ...prev, user_id: '' }));
                                    }
                                }}
                                onFocus={() => setShowUserDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="user_id">
                                <FontAwesomeIcon icon={faUser} />
                                {translations.selectUser || 'Select User'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showUserDropdown && (
                            <div className="ozui-category-dropdown">
                                {loadingUsers ? (
                                    <div className="ozui-loading-state">{translations.loadingUsers || 'Loading users...'}</div>
                                ) : filteredUsers.length > 0 ? (
                                    filteredUsers.map(u => (
                                        <div
                                            key={u.id}
                                            className={`ozui-category-option ${formData.user_id === u.id ? 'ozui-selected' : ''}`}
                                            onClick={() => selectUser(u)}
                                        >
                                            <div className="ozui-option-main">{u.fullname || u.username}</div>
                                            <div className="ozui-option-sub">
                                                {u.email} {u.businessname && `| ${u.businessname}`}
                                                {u.status && ` | ${u.status}`}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">{translations.noUsers || 'No users available'}</div>
                                )}
                            </div>
                        )}
                        {errors.user_id && <small>{errors.user_id}</small>}
                    </div>

                    {/* Module Selection */}
                    <div className={`ozui-field ${errors.module ? 'ozui-error' : ''}`} ref={moduleDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="module"
                                value={moduleSearchTerm}
                                onChange={(e) => {
                                    setModuleSearchTerm(e.target.value);
                                    setShowModuleDropdown(true);
                                    if (formData.module) {
                                        setFormData(prev => ({ ...prev, module: '' }));
                                    }
                                }}
                                onFocus={() => setShowModuleDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="module">
                                <FontAwesomeIcon icon={faBox} />
                                {translations.module || 'Module'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showModuleDropdown && (
                            <div className="ozui-category-dropdown">
                                {loadingModules ? (
                                    <div className="ozui-loading-state">Loading modules...</div>
                                ) : filteredModules.length > 0 ? (
                                    filteredModules.map(m => (
                                        <div
                                            key={m.id}
                                            className={`ozui-category-option ${formData.module === m.module_code ? 'ozui-selected' : ''}`}
                                            onClick={() => selectModule(m)}
                                        >
                                            <div className="ozui-option-main">{m.module_name}</div>
                                            <div className="ozui-option-sub">{m.module_description}</div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No modules available</div>
                                )}
                            </div>
                        )}
                        {errors.module && <small>{errors.module}</small>}
                    </div>

                    {/* Package Type */}
                    <div className={`ozui-field ${errors.package_type ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <select
                                id="package_type"
                                name="package_type"
                                value={formData.package_type}
                                onChange={handleChange}
                                disabled={loading}
                            >
                                <option value="">{translations.selectPackageType || 'Select Package Type'}</option>
                                <option value="yearly">{translations.yearly || 'Yearly'}</option>
                                <option value="6_months">{translations.sixMonths || '6 Months'}</option>
                                <option value="3_months">{translations.threeMonths || '3 Months'}</option>
                                <option value="monthly">{translations.monthly || 'Monthly'}</option>
                            </select>
                            <label htmlFor="package_type">
                                <FontAwesomeIcon icon={faClock} />
                                {translations.packageType || 'Package Type'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {errors.package_type && <small>{errors.package_type}</small>}
                    </div>

                    {/* Category */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <select
                                id="category"
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                disabled={loading}
                            >
                                <option value="production">{translations.production || 'Production'}</option>
                                <option value="custom">{translations.custom || 'Custom'}</option>
                                <option value="trial">{translations.trial || 'Trial'}</option>
                                <option value="demo">{translations.demo || 'Demo'}</option>
                            </select>
                            <label htmlFor="category">
                                <FontAwesomeIcon icon={faTag} />
                                {translations.category || 'Category'}
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                    </div>

                    {/* Installation Date */}
                    <div className={`ozui-field ${errors.installation_date ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="date"
                                name="installation_date"
                                id="installation_date"
                                value={formData.installation_date}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="installation_date">
                                <FontAwesomeIcon icon={faCalendar} />
                                {translations.installationDate || 'Installation Date'} <span>*</span>
                            </label>
                        </div>
                        {errors.installation_date && <small>{errors.installation_date}</small>}
                    </div>
                </div>

                {/* Pricing Section */}
                <div className="ozui-form-section">
                    <h3 className="ozui-section-title">
                        <FontAwesomeIcon icon={faMoneyBill} />
                        {translations.pricing || 'Pricing'}
                    </h3>
                    <div className="ozui-form-row ozui-pricing-row">
                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="initial_fee"
                                    id="initial_fee"
                                    value={formData.initial_fee}
                                    onChange={handleChange}
                                    placeholder=" "
                                    disabled={loading}
                                    step="0.01"
                                    min="0"
                                />
                                <label htmlFor="initial_fee">
                                    <FontAwesomeIcon icon={faCreditCard} />
                                    {translations.initialFee || 'Initial Fee'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="yearly_service_fee"
                                    id="yearly_service_fee"
                                    value={formData.yearly_service_fee}
                                    onChange={handleChange}
                                    placeholder=" "
                                    disabled={loading}
                                    step="0.01"
                                    min="0"
                                />
                                <label htmlFor="yearly_service_fee">
                                    <FontAwesomeIcon icon={faRefresh} />
                                    {translations.yearlyServiceFee || 'Yearly Service Fee'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper">
                                <input
                                    type="number"
                                    name="renewal_fee"
                                    id="renewal_fee"
                                    value={formData.renewal_fee}
                                    onChange={handleChange}
                                    placeholder=" "
                                    disabled={loading}
                                    step="0.01"
                                    min="0"
                                />
                                <label htmlFor="renewal_fee">
                                    <FontAwesomeIcon icon={faRefresh} />
                                    {translations.renewalFee || 'Renewal Fee'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field ozui-total-field">
                            <div className="ozui-input-wrapper ozui-total-wrapper">
                                <input
                                    type="text"
                                    id="total_amount"
                                    value={(parseFloat(formData.initial_fee || 0) + 
                                           parseFloat(formData.yearly_service_fee || 0) + 
                                           parseFloat(formData.renewal_fee || 0)).toFixed(2)}
                                    placeholder=" "
                                    disabled
                                    readOnly
                                    className="ozui-total-input"
                                />
                                <label htmlFor="total_amount">
                                    <FontAwesomeIcon icon={faMoneyBill} />
                                    {translations.totalAmount || 'Total Amount'}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Status Section */}
                <div className="ozui-form-section">
                    <h3 className="ozui-section-title">
                        <FontAwesomeIcon icon={faCog} />
                        {translations.advancedSettings || 'Advanced Settings'}
                    </h3>
                    <div className="ozui-form-row ozui-status-row">
                        <div className="ozui-field">
                            <div className="ozui-input-wrapper ozui-category-wrapper">
                                <select
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    disabled={loading}
                                >
                                    <option value="active">{translations.active || 'Active'}</option>
                                    <option value="inactive">{translations.inactive || 'Inactive'}</option>
                                    <option value="expired">{translations.expired || 'Expired'}</option>
                                    <option value="cancelled">{translations.cancelled || 'Cancelled'}</option>
                                    <option value="pending">{translations.pending || 'Pending'}</option>
                                </select>
                                <label htmlFor="status">
                                    <FontAwesomeIcon icon={faCheck} />
                                    {translations.status || 'Status'}
                                </label>
                                <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                            </div>
                        </div>

                        <div className="ozui-field">
                            <div className="ozui-input-wrapper ozui-category-wrapper">
                                <select
                                    id="payment_status"
                                    name="payment_status"
                                    value={formData.payment_status}
                                    onChange={handleChange}
                                    disabled={loading}
                                >
                                    <option value="paid">{translations.paid || 'Paid'}</option>
                                    <option value="unpaid">{translations.unpaid || 'Unpaid'}</option>
                                    <option value="partial">{translations.partial || 'Partial'}</option>
                                    <option value="overdue">{translations.overdue || 'Overdue'}</option>
                                </select>
                                <label htmlFor="payment_status">
                                    <FontAwesomeIcon icon={faCreditCard} />
                                    {translations.paymentStatus || 'Payment Status'}
                                </label>
                                <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                            </div>
                        </div>

                        <div className="ozui-field ozui-checkbox-field">
                            <div className="ozui-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="auto_renew"
                                    name="auto_renew"
                                    checked={formData.auto_renew === 1}
                                    onChange={(e) => setFormData(prev => ({ 
                                        ...prev, 
                                        auto_renew: e.target.checked ? 1 : 0 
                                    }))}
                                    disabled={loading}
                                />
                                <label htmlFor="auto_renew">
                                    <FontAwesomeIcon icon={faRefresh} />
                                    {translations.autoRenew || 'Auto Renew'}
                                </label>
                            </div>
                        </div>

                        <div className="ozui-field ozui-checkbox-field">
                            <div className="ozui-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="is_trial"
                                    name="is_trial"
                                    checked={formData.is_trial === 1}
                                    onChange={(e) => setFormData(prev => ({ 
                                        ...prev, 
                                        is_trial: e.target.checked ? 1 : 0 
                                    }))}
                                    disabled={loading}
                                />
                                <label htmlFor="is_trial">
                                    <FontAwesomeIcon icon={faRocket} />
                                    {translations.isTrial || 'Is Trial'}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Notes */}
                <div className="ozui-form-row">
                    <div className="ozui-field ozui-full-width">
                        <div className="ozui-input-wrapper">
                            <textarea
                                name="notes"
                                id="notes"
                                value={formData.notes}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                                rows="3"
                            />
                            <label htmlFor="notes">
                                <FontAwesomeIcon icon={faFileAlt} />
                                {translations.notes || 'Notes'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>
                </div>

                {/* Form Actions */}
                <div className="ozui-form-actions">
                    <button 
                        ref={submitButtonRef}
                        type="submit" 
                        className="ozui-btn ozui-btn-primary" 
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{formData.id ? translations.updating || 'Updating...' : translations.saving || 'Saving...'}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} />
                                <span>{formData.id ? translations.updateSubscription || 'Update Subscription' : translations.saveSubscription || 'Save Subscription'}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>

            {/* Subscriptions List */}
            {formData.user_id && (
                <div className="ozui-subscriptions-section">
                    <div className="ozui-subscriptions-header">
                        <h3>
                            <FontAwesomeIcon icon={faList} />
                            {translations.subscriptions || 'Subscriptions'}
                            <span className="ozui-subscriptions-count">({filteredSubscriptions.length})</span>
                        </h3>
                        <div className="ozui-subscriptions-filters">
                            <div className="ozui-search-box">
                                <FontAwesomeIcon icon={faSearch} className="ozui-search-icon" />
                                <input
                                    type="text"
                                    placeholder={translations.search || 'Search...'}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="ozui-filter-dropdown">
                                <select 
                                    value={filterStatus} 
                                    onChange={(e) => setFilterStatus(e.target.value)}
                                >
                                    <option value="all">{translations.all || 'All'}</option>
                                    <option value="active">{translations.activeSubscriptions || 'Active'}</option>
                                    <option value="expiring">{translations.expiringSoon || 'Expiring Soon'}</option>
                                    <option value="expired">{translations.expiredSubscriptions || 'Expired'}</option>
                                </select>
                                <FontAwesomeIcon icon={faFilter} className="ozui-filter-icon" />
                            </div>
                        </div>
                    </div>

                    {loadingSubscriptions ? (
                        <div className="ozui-loading-state">
                            <FontAwesomeIcon icon={faSpinner} spin />
                            <span>Loading subscriptions...</span>
                        </div>
                    ) : filteredSubscriptions.length === 0 ? (
                        <div className="ozui-empty-state">
                            <FontAwesomeIcon icon={faList} />
                            <p>{translations.noSubscriptions || 'No subscriptions found'}</p>
                        </div>
                    ) : (
                        <div className="ozui-subscriptions-grid">
                            {filteredSubscriptions.map(sub => (
                                <SubscriptionCard
                                    key={sub.id}
                                    subscription={sub}
                                    onRenew={handleRenew}
                                    onCancel={handleCancel}
                                    onEdit={handleEdit}
                                    onDelete={() => {}}
                                    onViewHistory={handleViewHistory}
                                    translations={translations}
                                    isRTL={isRTL}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AddSubscription;
